<template>
  <div>
    <el-row :gutter="20" style="margin:15px 5px;">
      <el-col :span="14">
        <div class="module">
          <p class="moduleTitle">设备数量</p>
          <el-row>
            <el-col :span="8" class="moduleItem">
              <p class="textCenter">总数量</p>
              <p class="textCenter normal">{{allCount}}</p>
            </el-col>
            <el-col :span="8" class="moduleItem">
              <p class="textCenter">运行中</p>
              <p class="textCenter success">{{onLineCount}}</p>
            </el-col>
            <el-col :span="8" class="moduleItem">
              <p class="textCenter">离线</p>
              <p class="textCenter danger">{{offLineCount}}</p>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="module">
          <p class="moduleTitle">授权日期</p>
          <el-row>
            <el-col :span="12" class="moduleItem">
              <p class="textCenter">即将过期</p>
              <p class="textCenter warning">{{toBeExpireCount}}</p>
            </el-col>
            <el-col :span="12" class="moduleItem">
              <p class="textCenter">已过期</p>
              <p class="textCenter danger">{{expiredCount}}</p>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin:0px 5px;">
      <el-col :span="24">
        <div class="module">
          <p class="moduleTitle">资源监控预警
            <i class="el-icon-s-tools fr" @click="dialogVisible=true" style="margin-top: 5px; cursor: pointer;"></i>
          </p>
          <el-row>
            <el-col :span="8" class="moduleItem">
              <p class="textCenter">硬盘使用率大于{{hardDiskUsed}}%</p>
              <p class="textCenter normal">{{hdUsedCount}}</p>
            </el-col>
            <el-col :span="8" class="moduleItem">
              <p class="textCenter">CPU使用率大于{{cpuUsed}}%</p>
              <p class="textCenter normal">{{cpuUsedCount}}</p>
            </el-col>
            <el-col :span="8" class="moduleItem">
              <p class="textCenter">内存使用率大于{{cacheUsed}}%</p>
              <p class="textCenter normal">{{ramUsedCount}}</p>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="编辑配置" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" label-width="150px">
        <el-form-item label="硬盘使用率">
          ><el-input-number size="mini" v-model="hardDiskUsed" controls-position="right" :min="1" :max="100" style="margin:0px 10px;"></el-input-number>%
        </el-form-item>
        <el-form-item label="CPU使用率">
          ><el-input-number size="mini" v-model="cpuUsed" controls-position="right" :min="1" :max="100" style="margin:0px 10px;"></el-input-number>%
        </el-form-item>
        <el-form-item label="内存使用率">
          ><el-input-number size="mini" v-model="cacheUsed" controls-position="right" :min="1" :max="100" style="margin:0px 10px;"></el-input-number>%
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="customCancel">取 消</el-button>
        <el-button type="primary" size="mini" @click="customOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Overview',
  data () {
    return {
      isCollapse: false,
      dialogVisible: false,
      hardDiskUsed: 80,
      cpuUsed: 80,
      cacheUsed: 80,
      cpuUsedCount: 0,
      hdUsedCount: 0,
      ramUsedCount: 0,
      allCount: 0,
      offLineCount: 0,
      onLineCount: 0,
      expiredCount: 0,
      toBeExpireCount: 0,
      storage: null,
      customSelected: [],
      schoolID: ''
    }
  },
  created () {
    this.storage = window.localStorage
    if (this.storage.getItem('customSelected')) {
      this.customSelected = this.storage.getItem('customSelected').split(',')
      this.hardDiskUsed = this.customSelected[0]
      this.cpuUsed = this.customSelected[1]
      this.cacheUsed = this.customSelected[2]
    } else {
      this.customSelected = [80, 80, 80]
    }
  },
  watch: {
    // 获取到学校ID
    '$store.state.schoolID': function (val) {
      this.schoolID = val
      this.getDeviceCountByUsed()
      this.getDeviceCountByStatus()
      this.getDeviceCountByExpireTime()
    }
  },
  methods: {
    customOk () {
      this.customSelected = [this.hardDiskUsed, this.cpuUsed, this.cacheUsed]
      this.storage.setItem('customSelected', this.customSelected)
      this.dialogVisible = false
    },
    customCancel () {
      this.hardDiskUsed = this.customSelected[0]
      this.cpuUsed = this.customSelected[1]
      this.cacheUsed = this.customSelected[2]
      this.dialogVisible = false
    },
    // 资源监控
    getDeviceCountByUsed () {
      this.$http.post(this.$store.state.host + '/api/2019/iot/CountDeviceByUsed', {SchoolID: this.schoolID, HDUsed: '>=' + this.hardDiskUsed, CPUUsed: '>=' + this.cpuUsed, RAMUsed: '>=' + this.cacheUsed}).then(res => {
        if (res.body.code === 200) {
          this.cpuUsedCount = res.body.data.cpuUsedCount
          this.hdUsedCount = res.body.data.hdUsedCount
          this.ramUsedCount = res.body.data.ramUsedCount
        }
      })
    },
    // 设备数量
    getDeviceCountByStatus () {
      this.$http.post(this.$store.state.host + '/api/2019/iot/CountDeviceByStatus', {SchoolID: this.schoolID}).then(res => {
        if (res.body.code === 200) {
          this.allCount = res.body.data.allCount
          this.offLineCount = res.body.data.offLineCount
          this.onLineCount = res.body.data.onLineCount
        }
      })
    },
    getDeviceCountByExpireTime () {
      this.$http.post(this.$store.state.host + '/api/2019/iot/CountDeviceByExpireTime', {
        SchoolID: this.schoolID,
        ToBeExpireDays: 7
      }).then(function (res) {
        if (res.body.code === 200) {
          this.expiredCount = res.body.data.expiredCount
          this.toBeExpireCount = res.body.data.toBeExpireCount
        }
      })
    }
  }
}
</script>

<style scoped>
  .module{
    background:#fff;
  }
  .module .moduleTitle{
    font-size: 18px;
    color: #303133;
    padding: 20px 15px;
    border-bottom: 1px solid #ebeef5;
  }
  .module .moduleItem p{
    border-right: 1px solid #ebeef5;
  }
  .module .moduleItem p:first-child{
    margin-top: 25px;
    font-size: 16px;
    padding-bottom: 20px;
  }
  .module .moduleItem p:last-child{
    margin-bottom: 25px;
    font-weight: 700;
    font-size: 30px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Overview.vue